import { useSelector } from 'react-redux';
import { userPaths } from 'routes/constants/userPaths';

import { Navigate, Outlet } from 'react-router-dom';

import type { RootState } from 'store/store';

const useExpenseCertificationConsentRoute = () => {
  const isConsentAccepted = useSelector(
    (state: RootState) => state.auth.endUserExpenseConfirmationConsentAccepted
  );

  return isConsentAccepted ? <Navigate to={userPaths.confirmCashback} replace /> : <Outlet />;
};

export default useExpenseCertificationConsentRoute;
